<template>
    <div class="wrapper">
        <div :class="['content', { spacings: hasSpacings }]">
            <slot/>
        </div>
    </div>
</template>

<<script>
    export default {
        name: 'NarrowContent',
        props: {
            hasSpacings: {
                type: Boolean,
                default: true
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .wrapper {
        display: flex;
        align-items: center;
        flex-grow: 1;
        width: 100%;
    }

    .content {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        max-width: 72rem;
        width: 100%;
    }

    .spacings {
        padding: 4rem;
        margin-bottom: 4rem;
    }

    @media all and (max-width: 1200px) {
        .spacings {
            padding: 2rem;
        }
    }
    
    @media all and (max-width: 1024px) {
        .spacings {
            padding: 2rem 1rem;
        }
    }

    @media all and (max-width: 640px) {
        .spacings {
            padding: 2rem 0.5rem;
        }
    }
</style>